export const SET_POSTS = "SET_POSTS";
export const CLEAR_POSTS = "CLEAR_POSTS";
